import { AfterViewInit, Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Subscription } from 'rxjs';
import { CustomerspagesService } from '../customerspages.service';
import { HubspotCustomFormService } from 'src/app/shared/services/hubspot-custom-form.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-customers-hero',
  templateUrl: './customers-hero.component.html',
  styleUrls: ['./customers-hero.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
})
export class CustomersHeroComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private customFormService: HubspotCustomFormService,
    private customersPagesService: CustomerspagesService
  ) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  heroData: any;

  ngOnInit(): void {
    this.customersPagesService.customersData$.subscribe(data => {
      if (data != null) {
        let hero = data?.customerStoriesLandingPageHeroPanel?.fields;
        this.heroData = {
          header: hero?.title || '',
          paragraph: hero?.content || '',
          images: hero?.component1,
          button1: {
            text: hero?.buttons?.[0]?.fields?.buttonText || '',
            url: hero?.buttons?.[0]?.fields?.redirectLink || '',
            target: hero?.buttons?.[0]?.fields?.actionType || '',
          },
          button2: {
            text: hero?.buttons?.[1]?.fields?.buttonText || '',
            url: hero?.buttons?.[1]?.fields?.redirectLink || '',
            target: hero?.buttons?.[1]?.fields?.actionType || '',
          },
        };
      }
    });
  }

  ngAfterViewInit() {
    this.customFormService.generateCustomForm('bg-white');
  }
  openPage(url: string) {
    const isServer = !isPlatformBrowser(this.platformId);
    if (isServer) return;
    if (url) {
      let link = url;
      window.open(link, '_self');
    } else {
      return;
    }
  }
}
